import { render } from "./CartItem.vue?vue&type=template&id=0486e5ed"
import script from "./CartItem.vue?vue&type=script&lang=js"
export * from "./CartItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/WebstormProjects/ynamly_vue-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__